export interface GallerySlide {
  title: string
  src: string
  alt: string
}

export const insideItems: string[] = [
  'Visual system diagrams',
  'Component breakdowns',
  'Workshop procedures',
  'Diagnostic workflows',
  'Comparisons',
  'Lesson structures',
  'Professional instructor tools',
]

export const gallerySlides: GallerySlide[] = [
  {
    title: 'Know What You Can Touch — HV Safety Zones',
    src: 'https://cdn.magicpatterns.com/uploads/on1avJJgWr1mPo3inb4ssY/Captura_de_pantalla_2026-09-30_210351.png',
    alt: 'Hybrid/EV safety zone diagram with green, amber and red service areas, required PPE and a four-step HV safety sequence',
  },
  {
    title: 'High-Voltage Vehicle System Overview',
    src: 'https://cdn.magicpatterns.com/uploads/ir1zMq1MgNZrxiVTHy35bq/Captura_de_pantalla_2026-09-30_210308.png',
    alt: 'Hybrid/EV architecture diagram showing battery pack, inverter, DC-DC converter, electric drive motor, on-board charger and charge port',
  },
  {
    title: 'How ABS Prevents Wheel Lock',
    src: 'https://cdn.magicpatterns.com/uploads/1J8Gfmuxf3K3aenVgB8HeF/Captura_de_pantalla_2026-09-30_210243.png',
    alt: 'ABS system diagram with four wheel-speed sensors, ABS module, hydraulic control unit and master cylinder',
  },
  {
    title: 'Cranks But Does Not Start — Diagnostic Decision Tree',
    src: 'https://cdn.magicpatterns.com/uploads/n1CSyLhtR5F8HuH2Lh9t3H/Captura_de_pantalla_2026-09-30_210219.png',
    alt: 'Six-step crank/no-start diagnostic tree covering cranking speed, spark, injector pulse, fuel pressure, compression and timing',
  },
  {
    title: 'OBD-II: The Vehicle’s Diagnostic Gateway',
    src: 'https://cdn.magicpatterns.com/uploads/qRj3UNJPxYkuwLw5yk6JQ7/Captura_de_pantalla_2026-09-30_210154.png',
    alt: 'OBD-II diagram showing sensors feeding the ECU/PCM, the 16-pin data link connector and a scan tool with live data and DTCs',
  },
]
